module.exports = "/images/mandarin-untuk-bisnis.jpg?a7e6f3b12bb4553b44529a21440c81f6";